// React
import React, { useState } from "react";

// Libraries
import { SketchPicker } from "react-color";
import PropTypes from "prop-types";

// Styles
import styles from "./styles.module.css";

const ColorPicker = ({ currentColor, setCurrentColor, disabled }) => {
	const [displayColorPicker, setDisplayColorPicker] = useState(false);

	const handleOpen = () => {
		if (!disabled) {
			setDisplayColorPicker(!displayColorPicker);
		}
	};

	const handleClose = () => {
		setDisplayColorPicker(false);
	};
	const handleChangeCurrentColor = (color) => {
		setCurrentColor(color.hex);
	};

	return (
		<div>
			<div role="button" tabIndex={-1} onClick={handleOpen} className={styles.swatch}>
				<div
					style={{
						backgroundColor: currentColor,
					}}
					className={styles.color}
				/>
			</div>
			{displayColorPicker && !disabled && (
				<div className={styles.popover}>
					<div role="button" tabIndex={-1} onClick={handleClose} className={styles.cover} />
					<SketchPicker color={currentColor} onChange={handleChangeCurrentColor} />
				</div>
			)}
		</div>
	);
};

ColorPicker.propTypes = {
	currentColor: PropTypes.string,
	setCurrentColor: PropTypes.func,
	disabled: PropTypes.bool,
};

export default ColorPicker;
